import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AlumnoLayout from "@/components/AlumnoLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function MisProgramas() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/alumno/enrollments").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <AlumnoLayout user={user}>
      <div>
        <p className="text-xs uppercase tracking-widest text-[#93C5FD] font-semibold">Programas</p>
        <h1 className="mt-2 text-3xl font-bold text-white font-display">Mis programas</h1>
        <p className="mt-2 text-gray-400">Todos los programas que tienes asignados por tu institución.</p>

        <div className="mt-8">
          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {Array.from({ length: 3 }).map((_, i) => (<div key={i} className="h-40 bg-[#111827] border border-gray-800 rounded-xl animate-pulse" />))}
            </div>
          ) : items.length === 0 ? (
            <div className="p-8 border border-dashed border-gray-800 rounded-xl text-center text-gray-400">
              Sin programas asignados.
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="programs-list">
              {items.map((e) => (
                <Link key={e.id} to={`/app/alumno/programas/${e.program_id}`}
                  data-testid={`program-tile-${e.program_id}`}
                  className="p-5 bg-[#111827] border border-gray-800 rounded-xl hover:border-[#3B82F6]/60 transition-all group">
                  <div className="flex items-start justify-between">
                    <span className="text-[10px] uppercase tracking-widest text-gray-400">{e.program_format}</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded uppercase font-semibold ${
                      e.status === "completed" ? "bg-emerald-500/10 text-emerald-300 border border-emerald-500/30" :
                      "bg-brand-orange-500/10 text-brand-orange-300 border border-primary/30"
                    }`}>{e.status}</span>
                  </div>
                  <h3 className="mt-2 text-base font-semibold text-white group-hover:text-[#93C5FD]">{e.program_title}</h3>
                  <div className="mt-4 flex items-center gap-2">
                    <div className="flex-1 h-1.5 bg-white/10 rounded-full overflow-hidden">
                      <div className="h-full bg-[#3B82F6]" style={{ width: `${e.progress.percent}%` }} />
                    </div>
                    <span className="font-mono text-xs text-white">{e.progress.percent}%</span>
                  </div>
                  <p className="mt-2 text-xs text-gray-500 flex items-center gap-1">
                    {e.progress.completed}/{e.progress.total} lecciones
                    <ArrowRight className="w-3 h-3 ml-auto text-[#93C5FD]" />
                  </p>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </AlumnoLayout>
  );
}
